export default __webpack_public_path__ + "static/illu_druckverfahren-und-beschriftungen-46f216cc533eb61b0b7f9608271d0bd0.svg";